<template>
  <span class="rounded-lg px-3 py-1 text-xs"
        :class="getBadgeClass()">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: "VBadge",
  props: ['type'],
  methods: {
    getBadgeClass() {
      switch (this.type) {
        case 'success':
          return 'bg-green/20 text-green'
        case 'danger':
          return 'bg-red/20 text-red'
        case 'warning':
          return 'bg-orange/20 text-orange'
        case 'info':
          return 'bg-blue/20 text-blue'
      }
    }
  }
}
</script>

<style scoped>

</style>